// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const nameText: TypographyProps = {
    css: css`
        width: 100%;
        margin-bottom: 2px;
        ${wrapInContainerStyles}
    `,
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.bold,
    color: "text.link",
};

productBrandStyles.nameText = nameText;

productBrandStyles.nameLink = {
    typographyProps: nameText,
    css: css`
        width: fit-content;
    `,
};
